<template>
  <div style="display:inline-block">
    <el-select
      v-if="!tag"
      size="mini"
      :placeholder="placeholder"
      :clearable="true"
      v-model="tempValue"
      @change="handleSelect"
    >
      <slot></slot>
      <el-option
        v-for="(item,index) in select_home[field]"
        :key="index"
        :label="item.label"
        :value="item.id"
      ></el-option>
    </el-select>
    <span v-for="(item,index) in select_home[field]" :key="index" v-if="tag">
      <el-tag
        v-if="tempValue == item.id"
        size="mini"
        :type="item.type"
      >{{ item.label }}</el-tag>
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tempValue: '',
      select_home: {
        ai_status: [
          {label: '待生成', id: -3, type: 'info'},
          {label: '生成中', id: -2, type: 'info'},
          {label: '默认', id: -1, type: 'info'},
          {label: '待翻译', id: 0, type: 'info'},
          {label: '翻译中', id: 1, type: 'danger'},
          {label: '已翻译', id: 2, type: 'success'},
          {label: '翻译失败', id: 3, type: 'danger'},
        ],
        is_delete: [
          {label: '正常', id: 0, type: 'info'},
          {label: '已删除', id: 1, type: 'danger'},
        ],
        status_options: [
          {label: "待审核", id: 0, type: 'info'},
          {label: "启用", id: 1, type: 'success'},
          {label: "禁用", id: -1, type: 'danger'},
        ],
        limit_type: [
          {label: '全局', id: 1, type: 'info'},
          {label: '每月', id: 2, type: 'info'},
        ],
        ai_key_category: [
          {label: 'AwsClaudePool', id: 'AwsClaudePool', type: 'info'},
          {label: 'AwsNovaPool', id: 'AwsNovaPool', type: 'info'},
          {label: 'ThirdClaudePool', id: 'ThirdClaudePool', type: 'info'},
          {label: 'ThirdOpenaiPool', id: 'ThirdOpenaiPool', type: 'info'},
          {label: 'GcpGeminiPool', id: 'GcpGeminiPool', type: 'info'},
        ],
        is_vip: [
          {label: '普通', id: 0, type: 'info'},
          {label: 'vip', id: 1, type: 'success'},
        ]
      }
    };
  },
  props: ['value', 'tag', 'field', 'placeholder'],
  watch: {
    value() {
      this.tempValue = this.value;
    },
  },
  created() {
    this.tempValue = this.value;
  },
  methods: {
    handleSelect(v) {
      this.$emit('update:value', v);
    },
  },
};
</script>

<style>
.noLimitInput li {
  color: #409eff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/TagSelect.vue